import styled from "styled-components";
import { Colors } from "../config";
import FlightAbstractImg from "../assets/images/image_flighttravel.png";
import FromIcon from "../assets/images/from.png";
import ToIcon from "../assets/images/to.png";
import dayjs from "dayjs";

const JourneyData = ({ passengers, children, guests, formData }) => {
  // const displayPassengersName = (passengers, children, guests) => {
  //   if (passengers?.length > 0 && children?.length > 0) {
  //     return (
  //       <>
  //         <JourneyDetailsCell>
  //           <CellHeader>Passengers (Adult)</CellHeader>
  //           <PaxList>
  //             <PaxName>Wasim Abdul</PaxName>
  //             <PaxName>Sarah Wasim</PaxName>
  //           </PaxList>
  //         </JourneyDetailsCell>
  //         {children?.length > 0 && (
  //           <JourneyDetailsCell>
  //             <CellHeader>Children</CellHeader>
  //             <PaxList>
  //               <PaxName>Aisha Wasim</PaxName>
  //             </PaxList>
  //           </JourneyDetailsCell>
  //         )}
  //       </>
  //     );
  //   } else if (passengers.length > 0) {
  //     return (
  //       <>
  //         <JourneyDetailsCell>
  //           <CellHeader>Passengers (Adult)</CellHeader>
  //           <PaxList>
  //             <PaxName>Wasim Abdul</PaxName>
  //             <PaxName>Sarah Wasim</PaxName>
  //           </PaxList>
  //         </JourneyDetailsCell>
  //         <JourneyDetailsCell />
  //       </>
  //     );
  //   } else if (children?.length > 0) {
  //     return (
  //       <>
  //         <JourneyDetailsCell>
  //           <CellHeader>Children</CellHeader>
  //           <PaxList>
  //             <PaxName>Aisha Wasim</PaxName>
  //           </PaxList>
  //         </JourneyDetailsCell>
  //         <JourneyDetailsCell />
  //       </>
  //     );
  //   } else {
  //     return (
  //       <>
  //         <JourneyDetailsCell>
  //           <CellHeader>Guests</CellHeader>
  //           <PaxList>
  //             <PaxName>Wasim Abdul</PaxName>
  //             <PaxName>Sarah Wasim</PaxName>
  //           </PaxList>
  //         </JourneyDetailsCell>
  //         <JourneyDetailsCell />
  //       </>
  //     );
  //   }
  // };
  let childrenCount = passengers.filter(
    (pax) => pax.selected && pax.relationshipStatus.includes("Child")
  ).length;
  return (
    <JourneyDataContainer>
      <FlightAbstract src={FlightAbstractImg} />
      <JourneyDetails>
        <JourneyDetailsSection>
          <SectionHeader>
            {formData.returnJourney ? "Round Trip" : "One Way"}
          </SectionHeader>
          <SectionHeader>
            {formData.directFlight ? "Direct Flight" : ""}
          </SectionHeader>
          <JourneyDetailsCell>
            <CellHeader>Passengers (Adult)</CellHeader>
            <PaxList>
              {passengers.map(
                (pax) =>
                  pax.selected &&
                  !pax.relationshipStatus.includes("Child") && (
                    <PaxName>
                      {pax.firstName} {pax.lastName}
                    </PaxName>
                  )
              )}
              {guests.map((pax) => (
                <PaxName>
                  {pax.firstName} {pax.lastName}
                </PaxName>
              ))}
            </PaxList>
          </JourneyDetailsCell>
          <JourneyDetailsCell>
            <CellHeader>Passengers (Children)</CellHeader>
            <PaxList>
              {passengers.map(
                (pax) =>
                  pax.selected &&
                  pax.relationshipStatus.includes("Child") && (
                    <PaxName>
                      {pax.firstName} {pax.lastName}
                    </PaxName>
                  )
              )}
              {childrenCount === 0 && <span>-</span>}
            </PaxList>
          </JourneyDetailsCell>
          <div>
            <CellHeader>From</CellHeader>
            <DirectionCell>
              <HighlightJourneyText>{formData?.from}</HighlightJourneyText>
              <DirectionIcon src={FromIcon} />
            </DirectionCell>
          </div>
          <div>
            <CellHeader>To</CellHeader>
            <DirectionCell>
              <HighlightJourneyText>{formData?.to}</HighlightJourneyText>
              <DirectionIcon src={ToIcon} />
            </DirectionCell>
          </div>
          <div>
            <CellHeader>Departure Date & Time</CellHeader>
            <DirectionCell>
              <HighlightJourneyText>
                {dayjs(formData?.departureDate).format("MMM DD")}
              </HighlightJourneyText>
            </DirectionCell>
            <DayText>
              {dayjs(formData?.departureDate).format("ddd")},{" "}
              {formData?.departureTime}
            </DayText>
          </div>
          {formData.returnJourney && (
            <div>
              <CellHeader>Return Date & Time</CellHeader>
              <DirectionCell>
                <HighlightJourneyText>
                  {" "}
                  {dayjs(formData?.returnDate).format("MMM DD")}
                </HighlightJourneyText>
              </DirectionCell>
              <DayText>
                {dayjs(formData?.returnDate).format("dddd")},{" "}
                {formData?.returnTime}
              </DayText>
            </div>
          )}
        </JourneyDetailsSection>
      </JourneyDetails>
    </JourneyDataContainer>
  );
};

const JourneyDataContainer = styled.div`
  background: ${Colors.brandOne};
  width: 100%;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
`;

const FlightAbstract = styled.img`
  width: 100%;
  @media only screen and (max-width: 768px) {
  }
`;

const MobileFlightAbstract = styled.img`
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const JourneyDetails = styled.div`
  padding: 0 2.5rem 1rem 2.5rem;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 480px) {
    padding: 0 1rem 1rem 1rem;
  }
`;

const JourneyDetailsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem 2.688rem;
  @media only screen and (max-width: 480px) {
    gap: 1.5rem 1.75rem;
  }
`;

const SectionHeader = styled.div`
  color: ${Colors.brandFive};
  font-size: 1.5rem;
  font-weight: 400;
  @media only screen and (min-width: 769px) and (max-width: 1000px) {
    font-size: 1.125rem;
  }
  @media only screen and (max-width: 480px) {
    font-size: 1rem;
  }
`;

const JourneyDetailsCell = styled.div``;

const CellHeader = styled.div`
  color: ${Colors.brandTwo};
  font-size: 1.125rem;
  font-weight: 400;
  @media only screen and (max-width: 480px) {
    font-size: 0.75rem;
  }
`;

const HighlightJourneyText = styled.div`
  font-size: 2.5rem;
  font-weight: 600;

  @media only screen and (min-width: 769px) and (max-width: 1000px) {
    font-size: 2rem;
  }

  @media only screen and (max-width: 480px) {
    font-size: 1.75rem;
  }
`;

const DirectionCell = styled.div`
  display: flex;
  gap: 0.5rem;
  color: ${Colors.white};
  margin-top: 0.5rem;
  align-items: center;
`;

const DirectionIcon = styled.img`
  width: 45px;
  height: 32px;

  @media only screen and (max-width: 480px) {
    width: 33px;
    height: 24px;
  }
`;

const DayText = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${Colors.whiteOpacity40};

  @media only screen and (max-width: 768px) {
    font-size: 0.875rem;
  }

  @media only screen and (min-width: 769px) and (max-width: 1000px) {
    font-size: 1rem;
  }
`;

const PaxList = styled.div`
  display: flex;
  color: ${Colors.white};
  margin-top: 0.5rem;
  gap: 0.25rem;
  flex-direction: column;
`;

const PaxName = styled.div`
  font-size: 1.375rem;
  font-weight: 400;
  @media only screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;

export default JourneyData;
